import { createSlice } from "@reduxjs/toolkit";

export const agentsSlice = createSlice({
  name: "agents",
  initialState: {
    isOpen: false,
    mode: null, // 'pdf' or 'solutions'
    activeChallengeId: null,
    messages: [],
    loading: false,
    historyLoading: false,
    error: null,
    suggestions: [],
    suggestionsLoading: false,
  },
  reducers: {
    openPdfChat: (state) => {
      state.isOpen = true;
      state.mode = "pdf";
    },
    openSolutionChat: (state, action) => {
      state.isOpen = true;
      state.mode = "solutions";
      state.activeChallengeId = action.payload.challengeId;
    },
    closeChat: (state) => {
      state.isOpen = false;
      state.mode = null;
      state.activeChallengeId = null;
      state.suggestions = [];
    },
    fetchSuggestionsRequest: (state) => {
      state.suggestionsLoading = true;
    },
    fetchSuggestionsSuccess: (state, action) => {
      state.suggestionsLoading = false;
      state.suggestions = action.payload;
    },
    fetchSuggestionsFailure: (state) => {
      state.suggestionsLoading = false;
    },
    fetchHistoryRequest: (state) => {
      state.historyLoading = true;
      state.error = null;
    },
    fetchHistorySuccess: (state, action) => {
      state.historyLoading = false;
      state.messages = action.payload;
    },
    fetchHistoryFailure: (state, action) => {
      state.historyLoading = false;
      state.error = action.payload;
    },
    sendMessageRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    sendMessageSuccess: (state, action) => {
      state.loading = false;
      state.messages.push(action.payload);
    },
    sendMessageFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    appendUserMessage: (state, action) => {
      state.messages.push({ role: "user", content: action.payload });
    }
  },
});

export const {
  openPdfChat,
  openSolutionChat,
  closeChat,
  fetchSuggestionsRequest,
  fetchSuggestionsSuccess,
  fetchSuggestionsFailure,
  fetchHistoryRequest,
  fetchHistorySuccess,
  fetchHistoryFailure,
  sendMessageRequest,
  sendMessageSuccess,
  sendMessageFailure,
  appendUserMessage
} = agentsSlice.actions;

export default agentsSlice.reducer;